module.exports = __webpack_public_path__ + "media/images/favicons/favicon-16x16-3b5239947c8847327ace71237b2cb927.png";